const REDIRECT_KEY = 'POST_AUTH_REDIRECT';

export const setPostAuthRedirect = (route: {
  path: string;
  redirectionType?: string;
  query?: Record<string, any>;
}) => {
  localStorage.setItem(REDIRECT_KEY, JSON.stringify(route));
};

export const getPostAuthRedirect = () => {
  const raw = localStorage.getItem(REDIRECT_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

export const clearPostAuthRedirect = () => {
  localStorage.removeItem(REDIRECT_KEY);
};
